export const SNAP_THRESHOLD = 6;

const buildDragRect = (rect) => ({
  x: rect.x,
  y: rect.y,
  width: rect.width,
  height: rect.height,
  right: rect.x + rect.width,
  bottom: rect.y + rect.height,
  centerX: rect.x + rect.width / 2,
  centerY: rect.y + rect.height / 2,
});

export const collectSnapTargetsFromNodes = (
  designLayer,
  excludeIds,
  { includeCanvas = true } = {},
) => {
  const vertical = [];
  const horizontal = [];

  if (includeCanvas && designLayer?.attrs) {
    const {
      clipX = 0,
      clipY = 0,
      clipWidth = 0,
      clipHeight = 0,
    } = designLayer.attrs;
    if (clipWidth > 0 && clipHeight > 0) {
      vertical.push(clipX, clipX + clipWidth / 2, clipX + clipWidth);
      horizontal.push(clipY, clipY + clipHeight / 2, clipY + clipHeight);
    }
  }

  if (!designLayer?.getChildren) {
    return { vertical, horizontal };
  }

  designLayer.getChildren((child) => {
    const id = child.id();
    if (!id || excludeIds.has(id) || !child.getClientRect) {
      return;
    }
    const rect = child.getClientRect({ relativeTo: designLayer });
    const bounds = buildDragRect(rect);
    vertical.push(bounds.x, bounds.centerX, bounds.right);
    horizontal.push(bounds.y, bounds.centerY, bounds.bottom);
  });

  return { vertical, horizontal };
};

const findBestSnap = (values, targets, threshold) => {
  let bestDelta = 0;
  let bestGuide = null;
  let bestDistance = threshold + 1;

  values.forEach((value) => {
    targets.forEach((target) => {
      const delta = target - value;
      const distance = Math.abs(delta);
      if (distance <= threshold && distance < bestDistance) {
        bestDistance = distance;
        bestDelta = delta;
        bestGuide = target;
      }
    });
  });

  return { delta: bestDelta, guide: bestGuide };
};

/** Returns proximity guides and optional snap deltas (deltas are not applied during drag). */
export const computeDragSnapAdjustment = (dragRect, targets, threshold) => {
  const bounds = buildDragRect(dragRect);
  const xValues = [bounds.x, bounds.centerX, bounds.right];
  const yValues = [bounds.y, bounds.centerY, bounds.bottom];

  const snapX = findBestSnap(xValues, targets.vertical, threshold);
  const snapY = findBestSnap(yValues, targets.horizontal, threshold);

  return {
    dx: snapX.delta,
    dy: snapY.delta,
    guides: {
      vertical: snapX.guide == null ? [] : [snapX.guide],
      horizontal: snapY.guide == null ? [] : [snapY.guide],
    },
  };
};
